import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import Navigation from "../components/navigation"
import Disqus from "./disqus";
import 'prismjs/themes/prism-okaidia.css';

export default ({ children }) => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  )
  return (
    <div className="site-wrapper">
      <header className="site-header">
        <div className="site-title">
          <Link to="/">{data.site.siteMetadata.title}</Link>
        </div>
        <Navigation />
      </header>
      {children}
      <br/>
      <br/>
      <br/>
      <Disqus />
      <footer className="site-footer">
        <p>&copy; {new Date().getFullYear()} Memes Collection &bull; Crafted with <span role="img" aria-label="love" style={{color:"red"}}>❤️</span> by Meme Collections</p>
      </footer>
    </div>
  )
}
